import { FormControl } from '@angular/forms';
import { required } from '../form-control-options.constants';
import { BaseFormControls } from './base.form-controls';

export class SelectPlantsFormControls extends BaseFormControls {
  plants = new FormControl<string | null>(null, required);
}
